
export const ItemTypes = {
    product: 'product',
    recipe: 'recipe',
    event: 'event'
}

export const UrlPaths = {
    products: '/products',
    recipes: '/recipes',
    events: '/events'
}